var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImidVerificationSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#0CAF59",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5374_7342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.699 37.385L44.6674 60.415C44.5125 60.5705 44.3285 60.6938 44.1258 60.778C43.9232 60.8622 43.7059 60.9055 43.4865 60.9055C43.2671 60.9055 43.0498 60.8622 42.8472 60.778C42.6446 60.6938 42.4605 60.5705 42.3057 60.415L33.399 51.5C33.2442 51.3446 33.0602 51.2212 32.8575 51.137C32.6549 51.0529 32.4376 51.0095 32.2182 51.0095C31.9988 51.0095 31.7815 51.0529 31.5789 51.137C31.3762 51.2212 31.1922 51.3446 31.0374 51.5C30.8819 51.6549 30.7585 51.8389 30.6744 52.0415C30.5902 52.2442 30.5469 52.4614 30.5469 52.6808C30.5469 52.9003 30.5902 53.1175 30.6744 53.3202C30.7585 53.5228 30.8819 53.7068 31.0374 53.8617L39.9474 62.77C40.8873 63.7082 42.161 64.2351 43.489 64.2351C44.817 64.2351 46.0908 63.7082 47.0307 62.77L70.0607 39.745C70.2159 39.5902 70.339 39.4063 70.4231 39.2038C70.5071 39.0013 70.5503 38.7842 70.5503 38.565C70.5503 38.3458 70.5071 38.1287 70.4231 37.9262C70.339 37.7238 70.2159 37.5398 70.0607 37.385C69.9058 37.2296 69.7218 37.1062 69.5192 37.022C69.3165 36.9379 69.0993 36.8945 68.8799 36.8945C68.6604 36.8945 68.4432 36.9379 68.2405 37.022C68.0379 37.1062 67.8539 37.2296 67.699 37.385Z",
    fill: "#0CAF59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5374_7342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30.5 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImidVerificationSuccess);
export default __webpack_public_path__ + "static/media/imid-verification-success.a6eaa764a3c69710e1669be2d524dddd.svg";
export { ForwardRef as ReactComponent };